<template>
    <div>
        <time-picker-option @setTimeRange="setTimeRange"
            ref="timePickerOption"></time-picker-option>
        Step:
        <zm-input-number size="small" v-model="params.step" :min="1" class="monitor-number"></zm-input-number>
        <zm-select size="small" v-model="params.stepUnit" class="monitor-step-select">
            <zm-option label="Second" value="s"></zm-option>
            <zm-option label="Minute" value="m"></zm-option>
            <zm-option label="Hour" value="h"></zm-option>
            <zm-option label="Day" value="d"></zm-option>
        </zm-select>
        <zm-button type="icon" @click="refresh"
            class="zm-icon-refresh" size="small" :loading="loading"></zm-button>
        <zm-button type="primary" plain @click="showRp" style="float: right; margin-right: 10px;"
            class="zm-icon-settings" size="small" :loading="loading"></zm-button>
        <div class="monitor-container" v-for="(item, index) in metricsNameList" :key="index">
            <monitor :metricsName="item" :timeRange="timeRange" :ref="'monitor_' + index"
            :query="query"
            :timeZone="timeZone"
            :metricsNameList="metricsNameList" :labelkeys="labelkeys"
            :step="params.step" :stepUnit="params.stepUnit"
            @setTop="setTop"></monitor>
        </div>
        <zm-dialog title="Alter InfluxDb RP" :visible.sync="rpForm.rpVisible">
            <zm-form>
                <zm-form-item label="Retention Policy">
                    <div slot="label">
                        <tip label="Retention Policy" id="monitor-influxdb-policy"></tip>
                    </div>
                    <zm-input-number size="small" v-model="rpForm.step" :min="1"></zm-input-number>
                    <zm-select size="small" v-model="rpForm.stepUnit" style="margin-left: 5px;width: 100px">
                        <zm-option label="Second" value="s"></zm-option>
                        <zm-option label="Minute" value="m"></zm-option>
                        <zm-option label="Hour" value="h"></zm-option>
                        <zm-option label="Day" value="d"></zm-option>
                    </zm-select>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="rpForm.rpVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="saveRp()" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { alterRp, getMetricsNameList, getLabelList } from '@/api'
import monitor from './monitor'
import TimePickerOption from '@/components/TimeRangePicker/index'
import tip from 'components/ToolTip/index'
export default {
    name: 'monitorIndex',
    components: {
        TimePickerOption,
        monitor,
        tip
    },
    data () {
        return {
            loading: false,
            query: {
                key: '',
                value: ''
            },
            metricsNameList: [],
            timeZone: 0,
            timeRange: [],
            params: {
                endTime: 0,
                startTime: 0,
                step: 1,
                stepUnit: 'h'
            },
            labelkeys: [],
            rpForm: {
                rpVisible: false,
                step: 7,
                stepUnit: 'd'
            }
        }
    },
    created () {
        this.timeZone = -(new Date()).getTimezoneOffset() / 60
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 24 * 1000)
        this.params.startTime = start.valueOf()
        this.params.endTime = (new Date()).valueOf()
        this.timeRange = [this.params.startTime, this.params.endTime]
        if (this.$route.query) {
            this.query.key = this.$route.query.key
            this.query.value = this.$route.query.value
        }
        this.$nextTick(() => {
            this.$refs.timePickerOption.startTs = this.params.startTime
            this.$refs.timePickerOption.endTs = this.params.endTime
        })
        this.fetchMetricsNameList()
        this.fetchLabel()
    },
    methods: {
        setTimeRange (val, timeZone) {
            this.timeZone = timeZone
            this.params.startTime = val[0]
            this.params.endTime = val[1]
            this.timeRange[0] = val[0]
            this.timeRange[1] = val[1]
        },
        fetchMetricsNameList () {
            getMetricsNameList().then(response => {
                this.metricsNameList = response.metricsNames
            })
        },
        fetchLabel () {
            getLabelList().then(response => {
                response.labelsNames.map(key => {
                    this.labelkeys.push({
                        key: key,
                        active: true
                    })
                })
            })
        },
        refresh () {
            this.metricsNameList.map((item, index) => {
                this.$refs['monitor_' + index][0].fetchData()
            })
        },
        showRp () {
            this.rpForm.rpVisible = true
        },
        setTop (metric) {
            this.metricsNameList.map((item, index) => {
                if (item.metricsName === metric.metricsName && item.aggFunc === metric.aggFunc) {
                    this.metricsNameList.splice(index, 1)
                    this.metricsNameList.unshift(metric)
                }
            })
        },
        saveRp () {
            this.loading = true
            const value = this.rpForm.step + this.rpForm.stepUnit
            alterRp({ value }).then(response => {
                this.$message({
                    type: 'success',
                    message: 'Submit success'
                })
                this.loading = false
                this.rpForm.rpVisible = false
            }).catch(() => {
                this.loading = false
            })
        }
    }
}
</script>
<style>
.zm-date-editor.zm-input, .zm-date-editor.zm-input__inner {
    height: 32px;
    line-height: 26px;
}
.zm-date-editor .zm-range-separator {
    width: 5px;
}
.zm-date-editor--datetimerange.zm-input, .zm-date-editor--datetimerange.zm-input__inner {
    width: 360px;
}
.zm-date-editor .zm-range-input {
    width: 41%;
}
.monitor-number {
    width: 90px
}
.monitor-number.zm-input-number .zm-input__inner {
    border-radius: 8px 0 0 8px;
}
.monitor-number.zm-input-number.is-controls-right .zm-input-number__increase {
    border-radius: 0;
}
.monitor-number.zm-input-number.is-controls-right .zm-input-number__decrease {
    border-radius: 0;
    border-bottom: 0.5px solid #BABACC;
}
.monitor-step-select {
    width: 90px;
    margin-right: 20px;
    border-radius: 0 8px 8px 0;
}
.monitor-step-select.zm-select .zm-select-input {
    border-radius: 0 8px 8px 0;
    margin-left: -1px;
}
</style>
<style scoped>
.monitor-container {
    height: 50vh;
    margin-bottom: 20px;
}
</style>
